export default __webpack_public_path__ + "static/time-desktop-0b48ddbd9e6ca50647788a8148935435.gif";